<template>
    <div id="player_strip" v-if="episode" :class="{full: full}">
        <div class="bg_wrapper"  >
          <div class="bg" :style="bg(episode.pic_big != '' ? episode.pic_big : episode.podcast.pic_big)"></div>
          <div class="bg_shadow"></div>
        </div>

        <div id="mini_player">
            <div class="pic" :style="bg(episode.pic_big != '' ? episode.pic_big : episode.podcast.pic_big)"></div>
            <!-- <Like :item_id="episode.id" item_type="podcast" v-model="episode.podcast.user_liked"/> -->
            <div class="content">
                <div class="head_wrapper">
                    <ul class="links">
                        <li></li>
                    </ul>
                </div>
                <div class="player_wrapper">
                    <div class="big_play" @click.stop="isPlaying ? pausePlayer() : playPause()">
                        <button class="play" v-show="!isPlaying"><i class="fas fa-play"></i></button>
                        <button class="pause" v-show="isPlaying"><i class="fas fa-pause"></i></button>
                    </div>
                    <div class="episode_info">
                        <a :href="siteUrl" target="_blank" id="logo"></a>
                        <h4 class="pod_title" v-html="episode.podcast.title"></h4>
                        <a v-if="!isNull(episode.app_link)" target="_blank" :href="siteUrl + episode.app_link" class="name">{{episode.title}}</a>
                        <span class="episode_time"></span>
                    </div>
                </div>

                <div id="duration" v-text="(duration != 0 ? duration  : '')"></div>
                <div id="time" v-text="(time != 0 ? time  : '')"></div>

                
                <div class="mbl_player">
                        
                    <div class="controls_wrapper">
                        <button class="play_speed" @click="setSpeed()">{{speed}}x</button>
                        <button class="skip_forward" @click="skipForward()"> <span>15</span><i class="fa-solid fa-rotate-right"></i></button>
                        <!-- <button class="skip_forward" @click="skipForward()"><i class="fa-solid fa-rotate-right"></i></button> -->
                        
                        <!-- <button class="rewind" @click="skipBackward()"><i class="fa-solid fa-clock-rotate-left"></i></button> -->
                        <button class="rewind" @click="skipBackward()"> <span>15</span><i class="fa-solid fa-rotate-left"></i></button>

                    </div>
                    <audio  id="mbl_player" controls>
                        <source :src="this.episode.audio_parse" type="audio/mp3" />
                    </audio>
                </div>

            </div>
        </div>

    </div>            

</template>

<script>
import Plyr from 'plyr';
import 'plyr/dist/plyr.css'

// import Like from '@/components/like.vue'

export default { 
    name:'app',
    use: { Plyr },
    // components: { Like},
    props: ["programs"],
   
  data() {
    return {
        is_playing: false,
        currtime: Math.floor(Date.now() / 1000),
        episode: false,
        time: 0,
        speed: 1,
        duration: 0,
        mute: false,
        getTimeInterval: false,
        player: false,
        isPlaying: false,
        isLoading: false,
        saveTimer: false,
        full: false
    };
  },
  
  mounted(){
    const url = document.location.href;
    const parts = url.split('/');
    const id = parts[parts.length - 1];



        this.api({ action: 'episode/get', data:{id}}, (data)=>{
            if(data.data) 
            {
                this.episode = data.data;
                this.isLoading = true;
                this.$nextTick(()=>{
                    this.play(false);
                });
                window.document.title = `דוסקאסט - ${data.data.podcast.title} - ${data.data.title} - ${data.data.podcast.creator_parsed.display_name} - הטמעה`;
                gtag('event', 'page_view', {
                     page_path: this.$route.path,
                });
            }
        });
    this.$bus.$on('play', (episode) => { 

        if ((this.isNull(episode) && this.episode) || (this.episode.id == episode.id))
        {
            this.playPause(true);
        }
        else 
        {
            this.episode = episode;
            this.isLoading = true;
            this.$nextTick(()=>{
                this.play();
            });
        }
    });
    this.$bus.$on('pause', () => { 
        this.isPlaying = false;

        this.playerPause();
    });
    this.$bus.$on('seekTo', (startTime) => { 
        this.seekTo(startTime);
    });
    
    window.onpopstate = () => {
        if (this.full) this.full = false;
    }

  },
  methods: {
    playerPause(){
        this.player.pause();
    },
    playerPlay(){
        this.player.play();
    },
    playerSetVolume(vol){
        this.player.volume = vol;
    },
    playerGetCurrentTime(){
        return this.player.currentTime;
    },
    
    play(autoplay=true){  
        this.is_playing = autoplay;
        this.on_play(autoplay);
    },
    pausePlayer(){  
        this.$bus.$emit('pause');
    },
    playPause(init = false){
        const pod = this.episode.podcast;
        const podData = { podcast: pod.title, author: pod.creator_parsed.display_name, episode: this.episode.title };
        const { source } = this.$route.query;
        if(source) podData.source = source;

        gtag('event', 'podcast_play', podData);

        this.playerPlay();
        this.isPlaying = true;

        if (!init)
        {
            this.$bus.$emit('play',this.episode);
        }
    },
    changeVolume() {
        if(!this.mute) {
            this.playerSetVolume(0);
            this.mute = true;
        }
        else{
            this.playerSetVolume(1);
            this.mute = false;
        }
    },
    skipBackward() {
        this.player.rewind(15);
    },
    skipForward(){
        this.player.forward(15);
    },
    seekTo(time){
        this.player.forward(parseInt(time));
    },
    setSpeed(){
        let speed = null;
        if(this.speed == 2){
            speed = 1;
        } else {
            speed = this.speed + 0.25;
        }
        this.player.speed = speed;
        this.speed = speed;
    },
    close(){
        this.$bus.$emit('pause');
        this.episode = false;
    },
    on_play(autoplay=true) {

        if (this.player)
        {
            this.player.destroy();
        }
            
        this.player = new Plyr('#mbl_player', {
            controls: [/*'play', 'mute',*/ 'progress', 'current-time'],
        });
        this.player.source = {
            type: 'audio',
            title: 'Example title',
            sources: [
                {
                src: this.episode.audio_parse,
                type: 'audio/mp3',
                }
            ],
        };

        this.player.on('ready', (/*event*/) => {
        //   const instance = event.detail.plyr;

            if (autoplay) this.playerPlay();
            this.isLoading = false;
            this.isPlaying = autoplay;

            // this.saveHistory();
        });

        this.player.on('timeupdate',  () => {

            if (!this.saveTimer)
            {
                this.saveTimer = setTimeout(() => { 
            // console.log('2');
                    if (this.isPlaying) {
                        this.saveHistory();
                    }
                    this.saveTimer = false;
                }, 10*1000);
            }
        });
        
        this.player.on('ended',  () => {
            this.saveHistory(true);
            this.loadNext();
            this.isPlaying = false;
        });

    },
    loadPrev(){
        this.api({ action: 'podcasts/get_prev', data: { episode_id: this.episode.id} }, (data) => { 
            //this.episode = data.data;
            //this.on_play();
            this.$bus.$emit('play', data.data);
        });
        // this.isLoading = true;
    },
    loadNext(){
        this.api({ action: 'podcasts/get_next', data: { episode_id: this.episode.id} }, (data) => { 
            //this.episode = data.data;
            //this.on_play();
            this.$bus.$emit('play', data.data);
        });
    },
    GetTime(){
        if(!this.player) return false;

        this.time = this.parseTime(this.playerGetCurrentTime())
        console.log(this.time)
    },
    parseDuration(){
        if(!this.player) return false;

        this.duration = this.parseTime(this.player.getDuration());
    },
    // saveHistory(finished = false){
    //     this.api({ action: 'podcasts/save_history', data: { episode_id: this.episode.id, time: this.playerGetCurrentTime(), is_finished: finished } });
    // }
    saveHistory(){
        if (this.saveHistoryOnLoad) return false;

        this.saveHistoryOnLoad = true;

        let duration = false;
        
        if (+this.episode.duration > 0 )
        {
            const audioElement = this.player.media;
            console.log(audioElement.duration);
            if (audioElement.duration > 0) duration = audioElement.duration; // Duration is in seconds

        }

        this.saveHistoryDo(this.episode.id, parseInt(this.playerGetCurrentTime()), duration).then(() => {
            this.saveHistoryOnLoad = false;
        });
        // this.api({ action: 'podcasts/save_history', data: { stats: true, embed_token: this.token, episode_id: this.episode.id, time: this.playerGetCurrentTime(), is_finished: finished } });
    },
    async saveHistoryDo(episodeID, time, duration = false)
		{
        return new Promise((resolve) => {
            let token = false;
        
            let play_tokens = {};
            if (!this.isNull(sessionStorage.getItem('play_tokens'))) play_tokens = JSON.parse(sessionStorage.getItem('play_tokens'));
        

            // remove old records

            // Calculate the time for 4 hours in milliseconds
            const fourHoursInMilliseconds = 4 * 60 * 60 * 1000;

            // Loop through the play_tokens object and filter out records with time more than 4 hours ago
            for (const key in play_tokens) 
            {
                if (play_tokens[key] && play_tokens[key].time) 
                {
                    const recordTime = play_tokens[key].time;
                    const timeDifference = Date.now() - recordTime;
                    if (timeDifference > fourHoursInMilliseconds) delete play_tokens[key];
                }
            }



            let found = play_tokens[episodeID] || false;

            if (found) token = found.token;
        
            this.api({ action: 'podcasts/save_history', data: { stats: true, episode_id: episodeID, time: time, play_token: token, duration: duration } }, (data) => { 
                if (data.data)
                {
                    play_tokens[episodeID] = {token: data.data, time: Date.now()};
                    sessionStorage.setItem('play_tokens', JSON.stringify(play_tokens));
                }
                resolve(); // Resolve the promise after the API call is completed.
            });
        });
    },
      
  },
  beforeUnmount () {
      clearInterval(this.getTimeInterval);
  }

}

</script>

<style lang="scss">
body { background: #000;  }
#player_strip { position: relative; height: 100vh; display: flex;    align-items: center; color:#fff; z-index: 99999999;overflow: hidden;
    
    &:not(.full) { 
        #mini_player { }
        #maxi_player { height: 0px; opacity: 0; padding: 0px; }
    }
    &.full { max-height: 99999px;
        #mini_player { display: none; }
        #maxi_player { opacity: 1; height: 100vh; padding: 25px; }
    }
}

#mini_player { display: flex; gap:10px; padding: 10px; align-items: center; position: relative;width: 100%;
    .pic {  background: center center; background-size: cover; border-radius: 3px;
        @media (max-width: 600px) {display: none;}
        @media (min-width: 600px) {height: 150px; width:150px;}
    }

    .controls_wrapper { width: fit-content; display: flex; justify-content: center; align-items: center; }
    .name { width: 150px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }

    .player_wrapper{display: flex; gap:var(--gap); margin-bottom: var(--gap); align-items: center;}
}

.mbl_player { width:100%; border-radius: 40px; display: flex; gap:var(--gap); background: rgba(0,0,0,0.35); padding-right: var(--gap);
  --plyr-audio-controls-background: transparent;
  --plyr-color-main: var(--primary_color);
  --plyr-audio-control-color-hover: #000;

  .plyr { flex: 1;}
}

.skip_forward, .rewind { position: relative; 
    span {     position: absolute; color: var(--primary_color); font-size: 8px; top: calc(50% - 1px); transform: translate(50%, -50%); font-weight: bold;} 
    &.skip_forward {  
        span { right: calc(50% + 1px);}
    }
    &.rewind {  
        span { right: calc(50% + -1px);}
    }
} 

.content { flex: 1;}

.bg_wrapper { position: absolute; inset: 0;
    .bg{-webkit-background-position: 50% 50%;background-position: 50% 50%;-webkit-background-size: cover;background-size: cover;bottom: 0;-webkit-filter: blur(20px);filter: blur(20px);left: 0;position: absolute;right: 0;top: 0;}

    .bg_shadow{background: rgba(0, 0, 0, 0.5);position: absolute;pointer-events: none;inset: 0;}
}

.big_play { background: var(--primary_color);align-self: flex-end; width: 50px; height: 50px; border-radius: 100%; display: flex; align-items: center; justify-content: center; cursor: pointer;
    svg, path { * { color: #000; } }
    button{line-height: 1;}
}


.controls_wrapper{ display: flex;gap: var(--gap); align-items: center; justify-content: center; width: 100%;
    button{
        &{color: var(--primary_color);width: 25px;}
        *{fill: var(--primary_color);}
    }
    .play_pause_btns button { font-size: 40px; }
}

#logo { height: 30px; display: block; background: url(./assets/logo.svg) no-repeat; background-size: contain; background-position: right; margin-bottom: 10px; }
</style>